(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["me-product-card"] && !Shopify.designMode) return;
  try {
    /*
   * Produits à plusieurs variantes : ouvre la fenêtre de choix de Booster (quick-add-dialog)
   * en réutilisant son composant natif. Sans ce composant, le lien vers la fiche produit s'applique.
   */
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('a[data-me-quick-choose]') : null;
    if (!trigger) return;
    const QuickAdd = customElements.get('quick-add-component');
    if (!QuickAdd || !document.getElementById('quick-add-dialog')) return;

    event.preventDefault();
    const quickAdd = new QuickAdd();
    const url = new URL(trigger.href, window.location.origin).toString();
    Object.defineProperty(quickAdd, 'productPageUrl', { get: () => url });
    quickAdd.dataset.productTitle = trigger.dataset.productTitle || '';
    trigger.setAttribute('aria-busy', 'true');
    Promise.resolve(quickAdd.handleClick(event))
      .catch(() => {
        window.location.href = url;
      })
      .finally(() => trigger.removeAttribute('aria-busy'));
  });

  // Après un ajout depuis la fenêtre de choix, on la ferme : le tiroir panier prend le relais.
  // On la ferme dès l'envoi, avant que le tiroir panier ne s'ouvre (sinon l'animation de fermeture se bloque).
  document.addEventListener(
    'submit',
    (event) => {
      const dialog = event.target instanceof Element ? event.target.closest('quick-add-dialog') : null;
      if (dialog && typeof dialog.closeDialog === 'function') dialog.closeDialog();
    },
    true
  );

  /*
   * Ajout rapide AJAX : POST /cart/add.js puis CartAddEvent (@theme/events),
   * que le tiroir panier de Booster écoute pour se rafraîchir et s'ouvrir.
   * À défaut (module indisponible, erreur réseau), envoi classique du formulaire.
   */
  if (!customElements.get('me-quick-add')) {
    class MeQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-me-quick-add-status]');
        if (!this.form) return;
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        clearTimeout(this.resetTimer);
      }

      announce(text) {
        if (!this.status) return;
        this.status.textContent = '';
        window.requestAnimationFrame(() => {
          this.status.textContent = text;
        });
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.getAttribute('aria-busy') === 'true') return;

        let events;
        try {
          events = await import('@theme/events');
        } catch (error) {
          this.form.submit();
          return;
        }

        this.setAttribute('aria-busy', 'true');
        clearTimeout(this.resetTimer);

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(
          (element) => element.dataset.sectionId
        );
        const formData = new FormData(this.form);
        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const response = await fetch(`${this.form.action}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.announce(data.description || data.message || this.dataset.errorText);
            this.dispatchEvent(
              new events.CartErrorEvent(this.form.id || '', data.message, data.description, data.errors)
            );
            return;
          }

          let itemCount = 1;
          try {
            const cart = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } }).then((r) =>
              r.json()
            );
            itemCount = cart.item_count;
          } catch (error) {
            /* Le compteur sera recalculé au prochain rendu */
          }

          const card = this.closest('[data-product-id]');
          this.dispatchEvent(
            new events.CartAddEvent({}, this.id || 'me-quick-add', {
              source: 'me-quick-add',
              itemCount,
              productId: card ? card.dataset.productId : undefined,
              variantId: String(formData.get('id')),
              sections: data.sections,
            })
          );

          this.dataset.state = 'added';
          this.announce(this.dataset.addedText);
          this.resetTimer = setTimeout(() => {
            delete this.dataset.state;
          }, 2000);
        } catch (error) {
          this.form.submit();
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('me-quick-add', MeQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
